var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tenant-tech-comment-detail email-preview" },
    [
      _c("div", { staticClass: "comment-detail__header" }, [
        _c("img", {
          directives: [
            {
              name: "region-img-src",
              rawName: "v-region-img-src",
              value: "email-logo-hkland.png",
              expression: "'email-logo-hkland.png'",
            },
          ],
          staticClass: "hkld-logo",
          attrs: { alt: "Hongkong Land" },
        }),
        _vm._v(" "),
        _vm.showRecipientsReadOnly
          ? _c("div", { staticClass: "section-mgn-btm recipient-list" }, [
              _vm.isTenant
                ? _c("div", [
                    _c("span", { staticClass: "small-mgn-right" }, [
                      _vm._v(_vm._s(_vm.$t("to")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.deep(_vm.sendRecipients, "to"))),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isTenant
                ? _c("div", [
                    _c("span", { staticClass: "small-mgn-right" }, [
                      _vm._v(_vm._s(_vm.$t("cc")) + ":"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.deep(_vm.sendRecipients, "cc"))),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "greeting section-mgn-btm" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.$t(
                  "tenantProjects.tenantViewComments.dearTenantRepresentatives",
                  [_vm.tenantCompanyInfo.name]
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "tenant-project-location section-mgn-btm" }, [
          _vm.isGreenFitOut
            ? _c("div", { staticClass: "font-bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("tenantProjects.greenFitOut.emailSubjectPrefix")
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.isPostfitout
            ? _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t("tenantProjects.postFitout.titleWithNumber", [
                        _vm.activeBatch.order ? _vm.activeBatch.order + 1 : "",
                      ])
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shouldNotShowSection
            ? _c("div", { staticClass: "tenant-project-location" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.isFitout
                        ? _vm.$t(
                            "tenantProjects.submission.alterationRenoWorks"
                          )
                        : _vm.$t("tenantProjects.submission.reinstatementWorks")
                    ) +
                    "\n      "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isGreenFitOut
            ? _c("div", { staticClass: "tenant-project-floor" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      "" +
                        (_vm.currentTenantProject.projectLocation || []).join(
                          ", "
                        )
                    ) +
                    ' ("' +
                    _vm._s(_vm.$t("tenancyProject.premises")) +
                    '")\n      '
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isGreenFitOut
            ? _c("div", { staticClass: "tenant-project-building" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.deep(
                        _vm.currentTenantProject,
                        "tenancy.building.fullName"
                      )
                    ) +
                    ' ("' +
                    _vm._s(
                      _vm.$t("tenantProjects.allTenantProjects.building")
                    ) +
                    '")\n      '
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "comment-detail__content section-mgn-btm email-preview__content",
        },
        [
          !_vm.isTenant && _vm.isBatchesView
            ? _c("div", { staticClass: "design-comment" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.actionTexts[
                        _vm.deep(_vm.activeBatch, "designComment.comment")
                      ]
                    ) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "consolidated-comment tech-comment" },
            [
              _c("div", { staticClass: "tech-comment-description greeting" }, [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.deep(
                        _vm.activeBatch,
                        "techComment.greetingDescription"
                      )
                    ),
                  },
                }),
              ]),
              _vm._v(" "),
              _vm.description
                ? _c(
                    "div",
                    {
                      staticClass: "comment-content description",
                      class: { "only-one": _vm.onlyDescription },
                    },
                    [
                      _c("div", {
                        staticClass: "none-x-scroll",
                        domProps: { innerHTML: _vm._s(_vm.description) },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.sortedComments, function (section, secIndex) {
                return _c(
                  "div",
                  { key: section.id, staticClass: "section-header" },
                  [
                    _c("p", [
                      _vm._v(
                        _vm._s(_vm.getAlphabet(secIndex)) +
                          " " +
                          _vm._s(section.value)
                      ),
                    ]),
                    _vm._v(" "),
                    _vm._l(section.sectionContent, function (line, lineIndex) {
                      return _c(
                        "div",
                        { key: lineIndex, staticClass: "comment-content" },
                        [
                          _c(
                            "pre",
                            {
                              staticClass:
                                "comment-content__line-value none-x-scroll",
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getPrefix(lineIndex)) +
                                  " " +
                                  _vm._s(line.value)
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                )
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "tech-comment-description closingDesc section-mgn-btm",
                },
                [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.deep(
                          _vm.activeBatch,
                          "techComment.closingDescription"
                        )
                      ),
                    },
                  }),
                ]
              ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.shouldNotShowSection
        ? [
            _vm.activeBatchDocs.length > 0
              ? _c("div", { staticClass: "active-batch__files" }, [
                  _c("label", { staticClass: "files-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tenantProjects.batchSubmittedFileList", [
                          _vm.deep(_vm.activeBatch, "order") + 1,
                        ])
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ol",
                    { staticClass: "file-list", attrs: { type: "1" } },
                    _vm._l(_vm.activeBatchDocs, function (doc) {
                      return _c("li", { key: doc.id }, [
                        _c("span", { staticClass: "file-name" }, [
                          _vm._v(_vm._s(_vm.getBatchDocName(doc))),
                        ]),
                      ])
                    }),
                    0
                  ),
                ])
              : _c("div", { staticClass: "active-batch__files" }, [
                  _c("label", { staticClass: "files-label" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("tenantProjects.batchSubmittedFileList", [
                          _vm.deep(_vm.activeBatch, "order") + 1,
                        ])
                      ) +
                        ": " +
                        _vm._s(_vm.$t("none"))
                    ),
                  ]),
                ]),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }